
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("k82rV", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $7c9064a5e3861b37$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Czech
var $7c9064a5e3861b37$export$2e2bcd8739ae039 = {
    'fabric.linkPicker.button.cancel': "Zru\u0161it",
    'fabric.linkPicker.button.insert': "Vlo\u017Eit",
    'fabric.linkPicker.button.save': "Ulo\u017Eit",
    'fabric.linkPicker.clearLink': 'Vymazat',
    'fabric.linkPicker.clearLinkText': 'Vymazat text',
    'fabric.linkPicker.hyperlink.searchLinkResults': "{count, plural, =0 {nebyly nalezeny \u017E\xe1dn\xe9 v\xfdsledky} one {{count,number} nalezen\xfd v\xfdsledek} few {{count,number} nalezen\xe9 v\xfdsledky} many {{count,number} nalezen\xe9ho v\xfdsledku} other {{count,number} nalezen\xfdch v\xfdsledk\u016F}}",
    'fabric.linkPicker.linkAriaLabel': "Zadejte nebo vlo\u017Ete odkaz do pole.",
    'fabric.linkPicker.linkHelperTextAriaLabel': "Text n\xe1pov\u011Bdy k\xa0zobrazen\xed pro odkaz",
    'fabric.linkPicker.linkHelperTextLabel': "Dejte tomuto odkazu n\xe1zev nebo popis.",
    'fabric.linkPicker.linkInvalid': 'Zadejte platnou adresu URL.',
    'fabric.linkPicker.linkLabel': 'Odkaz',
    'fabric.linkPicker.linkPlaceholder': "Vlo\u017Ete odkaz.",
    'fabric.linkPicker.linkTextAriaLabel': "Text k zobrazen\xed pro odkaz",
    'fabric.linkPicker.linkTextLabel': "Zobrazen\xfd text (voliteln\xe9)",
    'fabric.linkPicker.linkTextPlaceholder': "Text k\xa0zobrazen\xed",
    'fabric.linkPicker.listTitle.recentlyViewed': "Ned\xe1vno zobrazeno",
    'fabric.linkPicker.listTitle.results': "V\xfdsledky",
    'fabric.linkPicker.search.error.description': "Obnovte str\xe1nku nebo, pokud probl\xe9m p\u0159etrv\xe1v\xe1, kontaktujte <a>podporu Atlassian</a>.",
    'fabric.linkPicker.search.error.heading': "P\u0159i na\u010D\xedt\xe1n\xed dat se vyskytly probl\xe9my.",
    'fabric.linkPicker.search.error.retry': 'Obnovit',
    'fabric.linkPicker.search.linkAriaLabel': "N\xed\u017Ee se objev\xed n\xe1vrhy na z\xe1klad\u011B v\xe1mi napsan\xe9ho textu v\xa0poli.",
    'fabric.linkPicker.search.linkLabel': "Vyhledejte nebo vlo\u017Ete odkaz.",
    'fabric.linkPicker.search.linkPlaceholder': "Vyhledejte ned\xe1vn\xe9 odkazy nebo vlo\u017Ete nov\xfd.",
    'fabric.linkPicker.search.noResults.description': "Zkuste to znovu s\xa0jin\xfdm term\xednem.",
    'fabric.linkPicker.search.noResults.heading': "Va\u0161emu vyhled\xe1v\xe1n\xed neodpov\xeddaj\xed \u017E\xe1dn\xe9 v\xfdsledky.",
    'fabric.linkPicker.status.submitting': "Odes\xedl\xe1n\xed",
    'fabric.linkPicker.time.message.updated': "Aktualizov\xe1no: {time}",
    'fabric.linkPicker.time.message.viewed': 'Zobrazeno: {time}',
    'fabric.linkPicker.unhandledError.description': "Zkuste str\xe1nku na\u010D\xedst znovu.",
    'fabric.linkPicker.unhandledError.heading': "N\u011Bco se pokazilo"
};

});


//# sourceMappingURL=cs.4ba470ca.js.map
